import React from 'react';
import Dashboard from '../components/Dashboard/Dashboard';
import { DashboardProvider } from '../context/DashboardContext';

const DashboardPage = () => {
  return (
    <DashboardProvider>
      <Dashboard />
    </DashboardProvider>
  );
};

export default DashboardPage;

// Made with Bob
